














































































import {Component, Mixins} from 'vue-mixin-decorator';
import {Prop} from 'vue-property-decorator';
import {Inject} from 'inversify-props';

import {Notify} from '@/utils/Notify';

import {Device} from '@/model/network/device/Device';
import {DeviceTypeMetadata, DeviceType} from '@/model/network/device/DeviceType';

import {INetworkDeviceService} from '@/services/network/INetworkDeviceService';

import NetworkIpStatusDisplay from '@/components/Networking/Connection/NetworkIpStatusDisplay.vue';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {NetworkIpStatusDisplay},
})
export default class NetworkDevicesList extends Mixins<BaseComponent>(BaseComponent) {

  @Prop()
  public devices!: Device[];

  @Prop({default: false})
  public disabled!: boolean;

  @Prop({default: true})
  public actions!: boolean;

  @Inject(Symbol.for('INetworkDeviceService'))
  private deviceService!: INetworkDeviceService;

  private DeviceType = DeviceType;
  private deviceTypeMetadata = DeviceTypeMetadata;

  private reapplying = false;

  private async reapplyDevice(device: Device) {
    this.reapplying = true;
    try {
      await this.deviceService.reapply(device.Interface);
      this.$emit('needs-refresh');
      Notify.Info(this.logger, `Connection settings have been reloaded for device '${device.Interface}'`);
    } catch (error) {
      Notify.Error(this.logger, `Could not apply the device new configuration`, error);
    } finally {
      this.reapplying = false;
    }
  }

}
